<template>
  <div class="border_bottom">
    <div class="header mb-6">
      <vs-button
        color="dark"
        type="flat"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="p-0"
        @click="goBack()"
      ></vs-button>
      <div class="w-full justify-right">
        <h2
          class="pl-2"
        >{{ editRoute ? $t('labels.edit_designation') : $t('labels.add_designation') }}</h2>
      </div>
    </div>
    <div class="addedit-service center">
      <form @submit.prevent="checkValidation()" autocomplete="off">
        <vx-card class="addedit-service-card">
          <div class="vx-row w-full m-0">
            <div class="vx-col sm: w-full mb-4 p-0">
              <label>{{$t('labels.name')}}</label>
              <vs-input
                type="text"
                class="w-full mt-1"
                name="designation_name"
                maxlength="250"
                v-model="name"
                icon-no-border
                :placeholder="$t('labels.designation_name')"
                v-validate="'required'"
              />
              <span class="text-danger text-sm">{{ errors.first('designation_name') }}</span>
            </div>
          </div>
          <div class="mt-2 btn-lead flex justify-center">
            <vs-button
              class="vs-component vs-button md:w-auto md:mr-3 md:mt-0 md:mb-0 vs-button-primary vs-button-filled login-btn"
              :disabled="button_loading"
              id="create-designation"
              button="submit"
            >{{ editRoute ? $t('labels.update_designation') : $t('labels.add_designation') }}</vs-button>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: ""
    };
  },
  computed: {
    editRoute() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.setValidationMessage();
    if (this.editRoute) {
      this.getDesignation();
    }
  },
  methods: {
    checkValidation() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.createUpdateDesignation();
        }
      });
    },
    // API Integration for add-update designation
    async createUpdateDesignation() {
      let input = {
        name: this.name
      };
      let url = this.editRoute
        ? "/designations/update/" + this.editRoute
        : "/designations/create";
      let response = await this.getHTTPPostResponse(
        url,
        input,
        "#create-designation",
        true
      );
      if (response) {
        this.$router.push({ name: "Designation" });
      }
    },
    async getDesignation() {
      let response = await this.getHTTPGetResponse(
        "/designations/get/" + this.editRoute
      );
      if (response) {
        let data = response.data;
        let designation = data.designation;
        this.name = designation.name;
      }
    },
    goBack() {
      history.back();
    }
  }
};
</script>